import { PLAYER_FILE_TYPES } from "@/apps/player/services/players.service";

export default {
    namespaced: true,
    state: () => ({
        player: {},
        currentFileId: null,
        watched: [],
        menuOpen: false,
    }),
    getters: {
        isWatched: (state) => {
            return state.watched.indexOf(state.currentFileId) !== -1;
        },
        noHeadersFiles: (state) => {
            return state.player.files.filter(
                (file) => file.type !== PLAYER_FILE_TYPES.header && !file.hide && !file._deleted
            );
        },
        currentFile: (state) => {
            return state.player.files.find((file) => file.id === state.currentFileId) || {};
        },
    },
    mutations: {
        setPlayer(state, player) {
            state.player = player;
        },
        setCurrentFile(state, { file, updateUrl = true }) {
            const foundFile =
                state.player.files.find((f) => f.id === file.id) || state.player.files[0];
            if (foundFile) {
                state.currentFileId = foundFile.id;
                if (updateUrl) {
                    const newUrl = `${window.location.pathname}?file=${foundFile.id}`;
                    window.history.pushState({ path: newUrl }, "", newUrl);
                }
            }
        },
        setWatched(state, watched) {
            state.watched = watched;
        },
        setMenuOpen(state, value) {
            state.menuOpen = value;
        },
        addWatched(state, fileId) {
            const index = state.watched.indexOf(fileId);
            if (index === -1) {
                state.watched.push(fileId);
            }
        },
        removeWatched(state, fileId) {
            const index = state.watched.indexOf(fileId);
            if (index !== -1) {
                state.watched.splice(index, 1);
            }
        },
    },
};
